/**
 * Maps an array of ID-based items into a record keyed by item ID.
 *
 * @param items - Collection of ARS entities to index by ID.
 * @returns Record keyed by each entity ID.
 */
export const mapById = <TItem extends { id: string }>(items: TItem[]): Record<string, TItem> =>
  Object.fromEntries(items.map((item): [string, TItem] => [item.id, item]));
